var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuHome = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 39.54 39.44",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.13,15.77,25.4,14V10.19a.75.75,0,1,0-1.5,0V13l-3.79-2.52a1.86,1.86,0,0,0-2.05,0l-8,5.33a.75.75,0,0,0,.42,1.38.75.75,0,0,0,.41-.12l8.05-5.33a.35.35,0,0,1,.39,0l8,5.32a.75.75,0,0,0,.83-1.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.49,19.86a1.56,1.56,0,0,0-.73-1.33c-7-4.46-7.42-4.56-7.54-4.59-.29-.08-.35-.1-7.83,4.59a1.58,1.58,0,0,0-.74,1.34l0,7.22a.5.5,0,0,0,.5.5h5.64a.5.5,0,0,0,.5-.5V23.17a.33.33,0,0,1,.33-.33h2.78a.33.33,0,0,1,.33.33v3.92a.5.5,0,0,0,.5.5H27a.47.47,0,0,0,.35-.15.53.53,0,0,0,.15-.35l0-7.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.77,39.22a19.5,19.5,0,1,1,19.5-19.5A19.53,19.53,0,0,1,19.77,39.22Zm0-38a18.5,18.5,0,1,0,18.5,18.5A18.52,18.52,0,0,0,19.77,1.22Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_Home.7bc673d2.svg";
export { ForwardRef as ReactComponent };